import { REDUX_STORE } from '@funnels/constants';
import { ActiveRolesActionTypes, ActiveRolesReducerState } from '@funnels/types';

const initialState: ActiveRolesReducerState = {
  data: null,
  error: null,
};

export default function activeRolesReducer(
  state = initialState,
  action: ActiveRolesActionTypes
): ActiveRolesReducerState {
  switch (action.type) {
    case REDUX_STORE.ACTIVE_ROLES.ACTION_TYPES.UPDATE_ACTIVE_ROLES:
      return action.activeRoles.length === state.data?.length &&
        state.data.every((role) => action.activeRoles.includes(role))
        ? state
        : {
            ...state,
            data: action.activeRoles,
            error: null,
          };
    case REDUX_STORE.ACTIVE_ROLES.ACTION_TYPES.UPDATE_ACTIVE_ROLES_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
